import peopleImageNames from './people-images.json';

export const ROUTES = {
    LANDING: '/',
    HACK_THE_GLOBE: '/hacktheglobe',
    PANEL: '/thoughtleader',
    CURRICULUM: '/curriculum',
    LOCAL_EVENTS: '/localevents',
    TEAM: '/team',
    PODCAST: '/podcast',
    PODCAST_EPISODE: '/podcast/:episodeKey',
    COMMUNITY: '/community',
    SICP: '/socialimpactconsultingprogram',
};

export const EXTERNAL_LINKS = {
    FACEBOOK: 'https://www.facebook.com/globalspark.world',
    INSTAGRAM: 'https://www.instagram.com/global.spark',
    LINKEDIN: 'https://www.linkedin.com/company/global-spark-world/',
    TWITTER: 'https://twitter.com/geweek?lang=en',
    EMAIL: 'contactus@globalspark.world',
    HACKER_DASH: 'https://hack.globalspark.world',
    PANEL_REG: 'http://bit.ly/globalsparkpanel',
    HTG_APP: 'https://form.typeform.com/to/sy0FhvtE',
};

export const SOCIAL_MEDIA_IMAGE = {
    facebook_logo_black: require('../assets/images/socialMediaIcons/facebook_black.svg'),
    instagram_logo_black: require('../assets/images/socialMediaIcons/instagram_black.svg'),
    linkedin_logo_black: require('../assets/images/socialMediaIcons/linkedin_black.svg'),
    twitter_logo_black: require('../assets/images/socialMediaIcons/twitter_black.svg'),
    facebook_logo_white: require('../assets/images/socialMediaIcons/facebook_white.svg'),
    instagram_logo_white: require('../assets/images/socialMediaIcons/instagram_white.svg'),
    linkedin_logo_white: require('../assets/images/socialMediaIcons/linkedin_white.svg'),
    twitter_logo_white: require('../assets/images/socialMediaIcons/twitter_white.svg'),
    logo: require('../assets/images/logo/bright-bg-long.png'),
    logo_short: require('../assets/images/logo/bright-bg-short.png'),
    footer_graphics: require('../assets/images/home/footer-graphics.svg'),
};

export const HOME_IMAGE = {
    curriculum: require('../assets/images/home/curriculum.jpg'),
    htg: require('../assets/images/home/htg.jpg'),
    local_events: require('../assets/images/home/local-events.jpg'),
    speaker_panel: require('../assets/images/home/speaker-panel.jpg'),
    logo: require('../assets/images/home/logo.png'),
    arrow_bl: require('../assets/images/home/arrow_bl.png'),
    arrow_br: require('../assets/images/home/arrow_br.png'),
    arrow_top: require('../assets/images/home/arrow_top.svg'),
    arrow_l: require('../assets/images/home/arrow_l.png'),
    arrow_r: require('../assets/images/home/arrow_r.png'),
    arrow_c: require('../assets/images/home/arrow_c.png'),
    bg: require('../assets/images/home/bg.svg'),
    body_bg: require('../assets/images/home/body-bg.svg'),
    landing: require('../assets/images/home/landing.svg'),
    bg_impact_b: require('../assets/images/home/bg-impact-b.svg'),
    bg_impact_t: require('../assets/images/home/bg-impact-t.svg'),
    globe: require('../assets/images/home/globe.png'),
    landing_bg: require('../assets/images/home/landing_bg.jpeg'),
    impact: require('../assets/images/home/impact.png'),
    join_our_team: require('../assets/images/home/JoinOurTeam.png'),
    icon1: require('../assets/images/home/icon1.png'),
    icon2: require('../assets/images/home/icon2.png'),
    icon3: require('../assets/images/home/icon3.png'),
    objectives: require('../assets/images/home/OurObjectives.png'),
    objectives_arrow: require('../assets/images/home/objectives_arrow.png'),
    objectives_bg: require('../assets/images/home/objectives_bg.png'),
    partner_with_us: require('../assets/images/home/PartnerWithUs.png'),
    what_we_do1: require('../assets/images/home/whatwedo1.png'),
    what_we_do2: require('../assets/images/home/whatwedo2.png'),
    what_we_do3: require('../assets/images/home/whatwedo3.png'),
    what_we_do4: require('../assets/images/home/whatwedo4.png'),
    landing_p: [
        require('../assets/images/home/landing_p1.png'),
        require('../assets/images/home/landing_p2.png'),
        require('../assets/images/home/landing_p3.png'),
    ],
    rotating_globe: require('../assets/images/home/rotating_globe.png'),
    rect_sic: require('../assets/images/home/Rect_SIC.png'),
    rect_thoughtlp: require('../assets/images/home/Rect_ThoughtLP.png'),
    curr_ellipse1: require('../assets/images/home/Ellipse_Curri.png'),
    curr_ellipse2: require('../assets/images/home/Ellipse_Curri2.png'),
    htg_ellipse: require('../assets/images/home/Ellipse_Hacktheglobe.png'),
};

// Production imports are generated and validated before CRA builds the site.
export const PEOPLE_IMAGE = process.env.NODE_ENV === 'production'
    // eslint-disable-next-line import/no-unresolved, import/extensions -- Generated only for production builds.
    ? require('../assets/images/optimized_people')
    : Object.fromEntries(Object.entries(peopleImageNames).map(([key, name]) => [
        key,
        // eslint-disable-next-line import/no-dynamic-require -- Supported by both Webpack and Jest.
        require(`../assets/images/people/${name}.png`),
    ]));

export const HTG_IMAGE = {
    landing: require('../assets/images/htg/landing1.jpg'),
    bg: require('../assets/images/htg/bg.svg'),
    htg_2020: require('../assets/images/htg/htg-2020.jpg'),
    htg_design: require('../assets/images/htg/htg-design.jpg'),
    peoplechoice: require('../assets/images/htg/peoplechoice.jpg'),
    runnerup: require('../assets/images/htg/runnerup.jpg'),
    winner: require('../assets/images/htg/winner.jpg'),
    peoplechoice2021: require('../assets/images/htg/DermaSpect.jpg'),
    runnerup2021: require('../assets/images/htg/Argent.jpg'),
    winner2021: require('../assets/images/htg/reusableEats.jpg'),
    third2023: require('../assets/images/htg/CheckMate.jpg'),
    second2023: require('../assets/images/htg/AdaptEd.jpg'),
    first2023: require('../assets/images/htg/bagSHARE.jpg'),
    third2024: require('../assets/images/htg/third2024.jpg'),
    second2024: require('../assets/images/htg/second2024.jpg'),
    first2024: require('../assets/images/htg/first2024.jpg'),
    peoplechoice2025: require('../assets/images/htg/peoplechoice2025.jpg'),
    third2025: require('../assets/images/htg/third2025.jpg'),
    second2025: require('../assets/images/htg/second2025.jpg'),
    first2025: require('../assets/images/htg/first2025.jpg'),
    shoes: require('../assets/images/htg/shoes.png'),
    data: require('../assets/images/htg/data.png'),
    hands: require('../assets/images/htg/hands.png'),
    lightbulb: require('../assets/images/htg/lightbulb.png'),
    two_week: require('../assets/images/htg/two-week.jpg'),
    multidisciplinary: require('../assets/images/htg/multidisciplinary.jpg'),
    mentorship: require('../assets/images/htg/mentorship.jpg'),
    ngo: require('../assets/images/htg/ngo.jpg'),
    climate: require('../assets/images/htg/climate.svg'),
    economic: require('../assets/images/htg/economic.svg'),
    health: require('../assets/images/htg/health.svg'),
    society: require('../assets/images/htg/society.svg'),
    speaker1: require('../assets/images/htg/dr_peter_singer.jpg'),
    speaker2: require('../assets/images/htg/bas_sudmeijer.jpg'),
    htg_logo: require('../assets/images/htg/htg-logo.svg'),
    testimonial1: require('../assets/images/htg/testimonial1.png'),
    testimonial2: require('../assets/images/htg/testimonial2.png'),
    testimonial3: require('../assets/images/htg/testimonial3.png'),
    schedule1: require('../assets/images/htg/schedule1.svg'),
    schedule2: require('../assets/images/htg/schedule2.svg'),
    schedule3: require('../assets/images/htg/schedule3.svg'),
    bcgMentoring: require('../assets/images/htg/bcgMentoring.jpg'),
    kickoff: require('../assets/images/htg/kickoff.jpg'),
    firstPrize2023: require('../assets/images/htg/firstPrize2023.jpg'),
};

export const SPEAKER_IMAGE = {
    landing: require('../assets/images/speaker/landing.jpg'),
    sarah: require('../assets/images/speaker/sarah.jpg'),
    marieme: require('../assets/images/speaker/marieme.jpg'),
    omar: require('../assets/images/speaker/omar.png'),
    joe: require('../assets/images/speaker/joe.png'),
    mark: require('../assets/images/speaker/mark.jpg'),
    carla: require('../assets/images/speaker/carla.png'),
    jessie: require('../assets/images/speaker/jessie.png'),
    laura: require('../assets/images/speaker/laura.png'),
    janice: require('../assets/images/speaker/janice.png'),
    tim: require('../assets/images/speaker/tim.png'),
    andrew: require('../assets/images/speaker/andrew.png'),
    maureen: require('../assets/images/speaker/maureen.png'),
    jim: require('../assets/images/speaker/jim.png'),
    natasha: require('../assets/images/speaker/natasha.png'),
    page: require('../assets/images/speaker/page.png'),
    matt: require('../assets/images/speaker/matt.jpg'),
    donnel: require('../assets/images/speaker/donnel.png'),
    tina: require('../assets/images/speaker/tina.png'),
};

export const EVENTS_IMAGE = {
    landing: require('../assets/images/events/landing.jpg'),
    design_competition: require('../assets/images/events/design-competition.jpg'),
    public_events: require('../assets/images/events/public-events.jpg'),
    speaker_series: require('../assets/images/events/speaker-series.jpg'),
};

export const CURRICULUM_IMAGE = {
    landing: require('../assets/images/curriculum/landing.jpg'),
    covid: require('../assets/images/curriculum/covid.jpeg'),
    climate: require('../assets/images/curriculum/climate.jpeg'),
    chemeng: require('../assets/images/curriculum/chemeng.jpeg'),
    electricity: require('../assets/images/curriculum/electricity.jpg'),
    vaccine: require('../assets/images/curriculum/vaccine.jpeg'),
    bulb: require('../assets/images/curriculum/bulb.png'),
    screen: require('../assets/images/curriculum/screen.png'),
    search: require('../assets/images/curriculum/search.png'),
    graph1: require('../assets/images/curriculum/graph1.svg'),
    graph2: require('../assets/images/curriculum/graph2.png'),
    graph3: require('../assets/images/curriculum/graph3.png'),
    graph4: require('../assets/images/curriculum/graph4.png'),
};

export const SPONSORS_IMAGE = {
    stc: require('../assets/images/sponsors/stc.png'),
    bmo: require('../assets/images/sponsors/bmo.png'),
    mars: require('../assets/images/sponsors/mars.png'),
    bcg: require('../assets/images/sponsors/bcg.png'),
    otpp: require('../assets/images/sponsors/otpp.png'),
    uw: require('../assets/images/sponsors/uw.png'),
    ewb: require('../assets/images/sponsors/ewb.png'),
    western: require('../assets/images/sponsors/western.png'),
    ibm: require('../assets/images/sponsors/ibm.png'),
    gates: require('../assets/images/sponsors/gates.png'),
    gu: require('../assets/images/sponsors/gu.png'),
    clearbanc: require('../assets/images/sponsors/clearbanc.png'),
    uber_eats: require('../assets/images/sponsors/uber-eats.png'),
    growing_north: require('../assets/images/sponsors/growing-north.jpg'),
    agakhan: require('../assets/images/sponsors/agakhan.png'),
    sea: require('../assets/images/sponsors/sea.png'),
    soc: require('../assets/images/sponsors/soc.png'),
    uoft: require('../assets/images/sponsors/uoft.png'),
    ubc: require('../assets/images/sponsors/ubc.png'),
    celo: require('../assets/images/sponsors/celo.png'),
    leap: require('../assets/images/sponsors/leap.png'),
    google: require('../assets/images/sponsors/google.png'),
    wwf: require('../assets/images/sponsors/wwf.png'),
    wise: require('../assets/images/sponsors/wise.png'),
    cfcf: require('../assets/images/sponsors/cfcf.png'),
    nsbe: require('../assets/images/sponsors/nsbe.png'),
    munk: require('../assets/images/sponsors/munk.png'),
    degree_consulting: require('../assets/images/sponsors/180.png'),
    deloitte: `${process.env.PUBLIC_URL || ''}/images/sponsors/deloitte.svg`,
    yncn: require('../assets/images/sponsors/yncn.png'),
    ieee: require('../assets/images/sponsors/ieee.png'),
    blueprint: require('../assets/images/sponsors/blueprint.png'),
    uwpm: require('../assets/images/sponsors/uwpm.png'),
    pbsn: require('../assets/images/sponsors/pbsn.png'),
    wecca: require('../assets/images/sponsors/wecca.png'),
    wds: require('../assets/images/sponsors/wds.png'),
    wics: require('../assets/images/sponsors/wics.png'),
    uwimpact: require('../assets/images/sponsors/uwimpact.png'),
    uwfossil: require('../assets/images/sponsors/uwfossil.png'),
    uwclimate: require('../assets/images/sponsors/uwclimate.png'),
    sci: require('../assets/images/sponsors/sci.png'),
    bag: require('../assets/images/sponsors/bag.png'),
    bcgcfca: require('../assets/images/sponsors/bcgcfca.jpg'),
    enactus: require('../assets/images/sponsors/enactus.png'),
    enactus_hack: require('../assets/images/sponsors/enactus_hack.png'),
    uweng: require('../assets/images/sponsors/uweng.png'),
    wfp: require('../assets/images/sponsors/wfp.png'),
    hfh_uw: require('../assets/images/sponsors/hfh-uw.png'),
    gcc: require('../assets/images/sponsors/gcc.jpg'),
    mcmaster: require('../assets/images/sponsors/mcmaster.png'),
    td: require('../assets/images/sponsors/td.png'),
    flipp: require('../assets/images/sponsors/flipp.png'),
    darwin: require('../assets/images/sponsors/darwin.png'),
    ripple: require('../assets/images/sponsors/ripple.png'),
    voiceflow: require('../assets/images/sponsors/voiceflow.png'),
    thinkdata: require('../assets/images/sponsors/thinkdata.png'),
    cyclica: require('../assets/images/sponsors/cyclica.png'),
    united: require('../assets/images/sponsors/united.jpg'),
    rumie: require('../assets/images/sponsors/rumie.png'),
    bcch: require('../assets/images/sponsors/bcch.jpg'),
    global_medic: require('../assets/images/sponsors/global-medic.png'),
    nem: require('../assets/images/sponsors/nem.png'),
    mastercard: require('../assets/images/sponsors/mastercard.jpg'),
    grameen: require('../assets/images/sponsors/grameen.png'),
    loi: require('../assets/images/sponsors/loi.png'),
    gp: require('../assets/images/sponsors/gp.jpg'),
    ef: require('../assets/images/sponsors/ef.png'),
    reach_alliance: require('../assets/images/sponsors/reach_alliance.png'),
    eia: require('../assets/images/sponsors/eia.jpg'),
    science_rendezvous: require('../assets/images/sponsors/science_rendezvous.png'),
    hh_debates: require('../assets/images/sponsors/hh_debates.jpg'),
    uwo_debate: require('../assets/images/sponsors/uwo_debate.png'),
    uwux: require('../assets/images/sponsors/uwux.png'),
    sdg: require('../assets/images/sponsors/sdg.png'),
    impact_alliance: require('../assets/images/sponsors/impact_alliance.jpg'),
    food_kid: require('../assets/images/sponsors/food_kid.png'),
    ic3: require('../assets/images/sponsors/ic3.jpg'),
    uw_wise: require('../assets/images/sponsors/uw_wise.jpg'),
    jaj: require('../assets/images/sponsors/j&j.png'),
};

export const PAST_LOCAL_EVENTS_IMAGE = {
    uoft_vaccine: require('../assets/images/localEvents/uoft_vaccination_conundrum.jpg'),
    uoft_yncn: require('../assets/images/localEvents/uoft_yncn_fireside.jpg'),
    uoft_innovative: require('../assets/images/localEvents/uoft_innovative.jpg'),
    uoft_reach: require('../assets/images/localEvents/uoft_reach.jpg'),
    uw_design: require('../assets/images/localEvents/uw_design.jpg'),
    uw_products: require('../assets/images/localEvents/uw_products.jpg'),
    uw_women_tech: require('../assets/images/localEvents/uw_women_tech.jpg'),
    uw_health: require('../assets/images/localEvents/uw_health.jpg'),
    uw_eng_competition: require('../assets/images/localEvents/uw_eng_competition.jpg'),
    uw_geo: require('../assets/images/localEvents/uw_geo.jpg'),
};

export const PODCAST_IMAGE = {
    podcast_logo_square: require('../assets/images/podcast/podcast_logo_square.png'),
    podcast_logo_round: require('../assets/images/podcast/podcast_logo_round.png'),
    apple_podcast: require('../assets/images/podcast/apple_podcast.png'),
    google_podcast: require('../assets/images/podcast/google_podcast.png'),
    spotify_podcast: require('../assets/images/podcast/spotify_podcast.png'),
    youtube_podcast: require('../assets/images/podcast/youtube_podcast.jpg'),
};

export const COMMUNITY_IMAGE = {
    community_roundtable: require('../assets/images/community/community.svg'),
};

export const SICP_IMAGE = {
    sicp_intro_cartoon: require('../assets/images/sicp/sicp_intro_cartoon.png'),
    sicp_intro_background: require('../assets/images/sicp/sicp_intro_background.png'),
    rocket: require('../assets/images/sicp/rocket.png'),
    calendar: require('../assets/images/sicp/calendar.png'),
    trophy: require('../assets/images/sicp/trophy.png'),
    timeline_bar: require('../assets/images/sicp/timeline_bar.png'),
    abigail_okyere: require('../assets/images/sicp/abigail_okyere.png'),
    heather_mactaggart: require('../assets/images/sicp/heather_mactaggart.png'),
};

export const APPLICATION = {
    CURRENT_YEAR: 2025,
    SEASON: 'Fall',
    get NEXT_SEASON_FULL() {
        return `Next Application Season: ${this.SEASON} ${this.CURRENT_YEAR}`;
    },
};
